import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ButtonPushComponent,
  LoadingComponent,
  TitleComponent,
} from "../../components";
import { ModalLayout } from "../../layouts";
import { requestPatchFileAuthorization } from "../../services/requestPatch";
import { requestPostAuthorization } from "../../services/requestPost";
import { clearUpdateCombo } from "../../store/combo";
import { ModalContainer } from "../ModalContainer/ModalContainer";

export const CombosCreateHeaderContainer = () => {
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { comboData } = useSelector((state) => state.retrieveCombo);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toggleModalUpdate = () => {
    setIsOpenUpdate(!isOpenUpdate);
  };
  const canceledStateStyle = {
    fontSize: "15px",
    fontWeight: "bold",
  };

  const convertMap = (array) => {
    return array.map((item) => item.id);
  };

  const handleCreateCombo = async () => {
    const body = { ...comboData };
    body.channels && (body.channels = convertMap(body.channels));
    body.colections && (body.colections = convertMap(body.colections));
    body.tags && (body.tags = convertMap(body.tags));
    body.complements && (body.complements = convertMap(body.complements));

    body.gruposProductos = body?.gruposProductos.map((item) => ({
      name: item.name,
      order: item.order,
      number: item.number,
      products: item.products.map((product) => product.id),
    }));

    const token = localStorage.getItem("token");

    delete body.image;
    delete body.codigo;

    const image = comboData.image;

    let blob = await fetch(image.url).then((r) => r.blob());
    const file = new File([blob], image.name, { type: image.type });
    const formData = new FormData();
    formData.append("image", file);
    setIsLoading(true);
    requestPostAuthorization(`admin/combos/`, body, token).then(
      async (value) => {
        await requestPatchFileAuthorization(
          `admin/combos/${value.id}/`,
          formData,
          token
        );
        dispatch(clearUpdateCombo());
        setIsLoading(false);

        navigate("/combos");
      }
    );
  };

  return (
    <section className="OrderDetailHeaderContainer">
      <div className="OrderDetailHeaderContainer__title">
        <TitleComponent title="Crear Combo" />
      </div>
      <div className="OrderDetailHeaderContainer__container-button">
        <ButtonPushComponent name={"Crear Combo"} onClick={toggleModalUpdate} />
      </div>
      {isOpenUpdate && (
        <ModalLayout>
          <ModalContainer
            title="Crear Combo"
            msg="¿Está seguro que desea actualizar el combo?"
            style={canceledStateStyle}
            onClose={toggleModalUpdate}
            onConfirm={handleCreateCombo}
          />
        </ModalLayout>
      )}

      {isLoading && (
        <ModalLayout>
          <LoadingComponent />
        </ModalLayout>
      )}
    </section>
  );
};
